/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction, Slice } from '@reduxjs/toolkit';
import { JOB_ANY_DATE, JOB_VALUE_ALL } from 'scenes/jobs/constants';
import { JobItem } from 'scenes/jobs/types';
import { jobsApi } from 'services/newApi/jobsApi';
import { ResponseJobItem } from 'services/types';
import { mapResponseJobToJobItem } from 'shared/mappers/mapResponseJobToJobItem';

export interface JobsState {
  selectedType: string;
  selectedStatus: string;
  selectedStarted: string;
  jobsList: JobItem[];
}

const initialState: JobsState = {
  selectedStatus: JOB_VALUE_ALL,
  selectedType: JOB_VALUE_ALL,
  selectedStarted: JOB_ANY_DATE,
  jobsList: [],
};

export const jobsSlice: Slice<JobsState> = createSlice({
  name: 'jobsSlice',
  initialState,
  reducers: {
    updateStatus: (state, action: PayloadAction<string>) => {
      state.selectedStatus = action.payload;
    },

    updateType: (state, action: PayloadAction<string>) => {
      state.selectedType = action.payload;
    },

    updateStarted: (state, action: PayloadAction<string>) => {
      state.selectedStarted = action.payload;
    },
  },

  extraReducers: (builder) => {
    builder.addMatcher(
      jobsApi.endpoints.getTasks.matchFulfilled,
      (state, action: PayloadAction<ResponseJobItem[]>) => {
        const convertedJobs = action.payload.map(mapResponseJobToJobItem);
        state.jobsList = convertedJobs;
      }
    );
  },
});

export const { updateStatus, updateType, updateStarted } = jobsSlice.actions;
